import React from 'react';

// One unified row of provider icons. Dim/grayscale = not linked (click scrolls to that
// provider's panel to connect); full brand color + soft glow = connected (click scrolls to
// the panel to manage). Always visible — no dismiss.
const PROVIDERS = {
  spotify: {
    label: 'Spotify',
    color: '#1DB954',
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z" />
      </svg>
    ),
  },
  soundcloud: {
    label: 'SoundCloud',
    color: '#FF5500',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
        <path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c0-.057-.045-.1-.09-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.165 1.308c0 .055.045.094.09.094s.089-.045.104-.104l.21-1.319-.21-1.334c0-.061-.044-.09-.09-.09m1.83-1.229c-.061 0-.12.045-.12.104l-.21 2.563.225 2.458c0 .06.045.12.12.12.061 0 .105-.061.121-.12l.254-2.458-.254-2.548c-.016-.06-.061-.12-.121-.12m.945-.089c-.075 0-.135.06-.15.135l-.193 2.64.21 2.544c.016.077.075.138.149.138.075 0 .135-.061.15-.15l.24-2.532-.24-2.623c-.015-.089-.075-.135-.166-.135m1.155.36c-.005-.09-.075-.149-.159-.149-.09 0-.158.06-.164.149l-.217 2.43.2 2.563c0 .09.075.157.159.157.074 0 .148-.068.148-.158l.227-2.563-.227-2.444m.809-1.709c-.101 0-.18.09-.18.181l-.21 3.957.187 2.563c0 .09.08.164.18.164.094 0 .174-.09.18-.18l.209-2.563-.209-3.936c0-.104-.088-.18-.18-.18m.929-.914c-.104 0-.194.089-.194.194l-.166 4.65.181 2.548c0 .12.09.209.196.209.104 0 .193-.089.209-.209l.196-2.548-.196-4.635c-.015-.12-.104-.209-.209-.209m.884.24c-.118 0-.209.089-.209.216l-.196 4.395.196 2.532c0 .12.09.225.213.225.12 0 .21-.104.225-.225l.225-2.532-.225-4.394c-.015-.121-.105-.211-.225-.211m1.155-.914c-.135 0-.24.104-.24.24l-.166 5.055.181 2.518c.016.135.104.24.24.24s.24-.104.24-.24l.196-2.518-.196-5.056c0-.135-.104-.24-.24-.24m.929.15c-.135 0-.24.104-.255.239l-.135 4.906.135 2.503c.016.15.12.255.255.255.135 0 .24-.104.255-.255l.166-2.503-.166-4.906c-.015-.134-.12-.239-.255-.239m1.185.223c-.15 0-.271.121-.271.271l-.135 4.68.135 2.474c0 .149.121.27.271.27.149 0 .27-.121.27-.271l.15-2.473-.15-4.68c0-.15-.121-.271-.27-.271m.973-.749c-.045-.045-.104-.061-.164-.061-.061 0-.12.016-.166.061-.09.045-.135.135-.135.225v.104l-.135 5.294.061 1.319.061 1.155c0 .149.135.27.285.27.164 0 .285-.121.299-.271l.166-2.474-.166-5.412c0-.104-.061-.194-.15-.24m11.155 3.16c-.494 0-.959.104-1.395.271-.271-3.146-2.878-5.615-6.076-5.615-.78 0-1.545.15-2.219.42-.271.104-.33.209-.33.42v9.869c0 .225.164.404.375.42h9.646c1.921 0 3.481-1.545 3.481-3.465 0-1.921-1.56-3.481-3.481-3.481" />
      </svg>
    ),
  },
  discord: {
    label: 'Discord',
    color: '#5865F2',
    icon: (
      <svg width="15" height="15" viewBox="0 0 71 55" fill="currentColor">
        <path d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1099 30.1693C30.1099 34.1136 27.2801 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7637 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.7018 30.1693C53.7018 34.1136 50.9 37.3253 47.3178 37.3253Z" />
      </svg>
    ),
  },
};

export const ProviderConnectRow = ({ connected = {}, onNavigate }) => {
  const order = ['spotify', 'soundcloud', 'discord'];
  const connectedCount = order.filter((p) => connected[p]).length;
  return (
    <div
      data-testid="provider-connect-row"
      style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}
    >
      {order.map((p) => {
        const cfg = PROVIDERS[p];
        const isConnected = !!connected[p];
        return (
          <button
            key={p}
            type="button"
            data-testid={`provider-icon-${p}`}
            data-connected={isConnected ? 'true' : 'false'}
            onClick={() => onNavigate && onNavigate(p)}
            title={isConnected ? `${cfg.label} connected` : `Connect ${cfg.label}`}
            aria-label={isConnected ? `${cfg.label} connected` : `Connect ${cfg.label}`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '20px',
              height: '20px',
              padding: 0,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: isConnected ? cfg.color : '#6b7280',
              filter: isConnected ? `drop-shadow(0 0 5px ${cfg.color}bb)` : 'grayscale(1)',
              opacity: isConnected ? 1 : 0.45,
              transition: 'filter 0.2s ease, opacity 0.2s ease, transform 0.15s ease, color 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.18)';
              if (!isConnected) {
                e.currentTarget.style.filter = 'grayscale(0)';
                e.currentTarget.style.opacity = '0.9';
                e.currentTarget.style.color = cfg.color;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              if (!isConnected) {
                e.currentTarget.style.filter = 'grayscale(1)';
                e.currentTarget.style.opacity = '0.45';
                e.currentTarget.style.color = '#6b7280';
              }
            }}
          >
            {cfg.icon}
          </button>
        );
      })}
      <span
        data-testid="provider-connected-count"
        title={`${connectedCount} of 3 accounts connected`}
        style={{
          fontSize: '11px',
          fontWeight: 600,
          color: connectedCount === 3 ? '#22c55e' : (connectedCount > 0 ? '#b7bcd0' : '#8b90a5'),
          marginLeft: '2px',
          letterSpacing: '0.02em',
          whiteSpace: 'nowrap',
        }}
      >
        {connectedCount}/3
      </span>
    </div>
  );
};

export default ProviderConnectRow;
